export default __webpack_public_path__ + "static/media/Template - Action-Plan_A0.84d2288e.pdf";